import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { loadGalleryData } from "../../galleryApi";

// Route-effect component for "/" - the couple dashboard (Couple Header,
// Activity Carousel, On This Day, Recent Memories preview). Renders
// nothing itself; CoupleHeader.tsx/ActivityCarousel.tsx/RecentMemories.tsx
// (mounted unconditionally in AppRoot) own the actual rendering into
// #homeIntroView/#homeMemoriesView, which this only shows/hides - same
// pattern as every other Phase 10 route screen. loadGalleryData() is
// called here (not just on "/gallery") because RecentMemories/MemoriesRow
// both read appState.media, which "/" needs loaded even though the full
// gallery grid itself now lives on a different route.
export function HomeRouteScreen() {
  useVisibleContainer("homeIntroView");
  useVisibleContainer("homeMemoriesView");

  useEffect(() => {
    loadGalleryData();
  }, []);

  return null;
}
